import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import CardMembershipIcon from '@material-ui/icons/CardMembership';
import StorefrontIcon from '@material-ui/icons/Storefront';
import DashboardIcon from '@material-ui/icons/Dashboard';
import HomeIcon from '@material-ui/icons/Home';
import PublicIcon from '@material-ui/icons/Public';
import AssignmentIcon from '@material-ui/icons/Assignment';
import ViewListIcon from '@material-ui/icons/ViewList';
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Tooltip from '@material-ui/core/Tooltip';
import { MyMess,history } from '../../App';
import ViewModuleIcon from '@material-ui/icons/ViewModule';
import ExtensionIcon from '@material-ui/icons/Extension';
import { Permission} from '../../utils/Permission'; 

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
}));

export default  function(path, routeUrl, userType, userScopes){ 
  
  // trim last slash
  const url = routeUrl.replace(/\/$/, "");
  
  const [open, setOpen] = React.useState(true);

  const classes = useStyles();

  const handleClick = () => {
    setOpen(!open);
  };

  return (
  <div>
    <ListItem button onClick={() => history.push(`${url}`)}>
      <ListItemIcon>
        <HomeIcon />
      </ListItemIcon>
      <ListItemText primary={MyMess.home} />
    </ListItem>
    <ListItem button onClick={() => history.push(`${url}/kopapro`)}>
      <ListItemIcon>
        <StorefrontIcon />
      </ListItemIcon>
      <ListItemText primary={MyMess.kopapro} />
    </ListItem>
    {
      userType && userType == 'admin' &&     
    <ListItem button onClick={() => history.push(`${url}/merchant`)}>
      <ListItemIcon>
        <CardMembershipIcon />
      </ListItemIcon>
      <ListItemText primary={MyMess.merchant.merchant} />
    </ListItem>
    }

    {
       userType && userType == 'merchant' &&    
      <ListItem button onClick={() => history.push(`${url}/domains`)}>
      <ListItemIcon>
        <PublicIcon />
      </ListItemIcon>
      <ListItemText primary={MyMess.domains.title} />
    </ListItem>
    }
   
  </div>
)};
